import React from 'react';
import { Route } from 'react-router-dom';

import ProcessosJuridicosFicha from '../../Juridico/processosJuridicos/ProcessosJuridicosFicha';
import ProcessosJuridicosIndex from '../../Juridico/processosJuridicos/ProcessosJuridicosIndex';
import ProcessosJuridicosManifestacao from '../../Juridico/processosJuridicos/ProcessosJuridicosManifestacao';

const ProcessosJuridicosRoutes = () => {
  return (
    <>
      <Route path="procjur/processos" element={<ProcessosJuridicosIndex />} />
      <Route
        path="procjur/processos/ficha/dadosgerais"
        element={<ProcessosJuridicosFicha />}
      />
      <Route
        path="procjur/processos/ficha/:id/dadosgerais"
        element={<ProcessosJuridicosFicha />}
      />
      <Route
        path="procjur/processos/ficha/manifestacaotecnica"
        element={<ProcessosJuridicosManifestacao />}
      />
      <Route
        path="procjur/processos/ficha/:id/manifestacaotecnica"
        element={<ProcessosJuridicosManifestacao />}
      />
    </>
  );
};

export default ProcessosJuridicosRoutes;
